module.exports = __webpack_public_path__ + "media/application/images/iso-image-2026-b41e533c5ce3a0e874aa76708d3bf0ec.png";